/**
 * `/app/mockups/<ref>` — the route. A string that is not a mockup ref is the router's 404
 * before a request is made (session 48).
 */

import { isRef } from '@fareast/shared'
import { createFileRoute, notFound } from '@tanstack/react-router'

import { NotFound } from '../../../errors/NotFound.js'
import { ClientMockupPage } from '../../../pages/mockups/ClientMockupPage.js'

export const Route = createFileRoute('/app/mockups/$ref')({
  beforeLoad: ({ params }) => {
    if (!isRef('mockup', params.ref)) throw notFound()
  },
  notFoundComponent: NotFound,
  component: ClientMockupRoute,
})

function ClientMockupRoute() {
  const { ref } = Route.useParams()
  return <ClientMockupPage mockupRef={ref} />
}
